import styled from "styled-components";
import { Sizes } from "../../styles/Sizes";

export const Wrapper = styled.div`
    max-width: ${ Sizes.Wrapper };
    margin: 0 auto;
    padding: 0 ${ Sizes.WrapperPadding };
`